import { render, staticRenderFns } from "./moduleForm.vue?vue&type=template&id=5cab3524&"
import script from "./moduleForm.vue?vue&type=script&lang=ts&"
export * from "./moduleForm.vue?vue&type=script&lang=ts&"
import style0 from "./moduleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports